import { FR } from './france';

export const BL = FR;
